import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { companySelectors } from '../../../state/ducks/company';
import theme from './generator';

const LegacyThemeWrapper: React.FC = ({ children }) => {
  const whiteLabeling = useSelector(companySelectors.getWhiteLabeling);

  return (
    <ThemeProvider theme={theme(whiteLabeling.colors)}>
      {children}
    </ThemeProvider>
  );
};

export default LegacyThemeWrapper;
